export const delay = value => new Promise(resolve => setTimeout(resolve, value));
export async function waitUntil(fn, timeout) {
  const start = Date.now();
  while (!fn() && Date.now() - start < timeout) {
    await delay(50);
  }
}